import ApiClient from "./ApiClient";

/**
 * カスタマイズ帳票のレイアウト取得
 *
 * @param path 画面パス。指定した場合はそのメニューに紐づく帳票を1件のみ取得する。
 *             未指定の場合は独立メニュー化されていない帳票の一覧（セレクトボックス用）を取得する。
 */
export const getCustomReportLayoutOptions = async (
  path?: string
): Promise<any> => {
  const companyCode = sessionStorage.getItem("loginUser.companyCode") || "";
  const response = await ApiClient.get(
    `/v2/sales/list/standard/custom/layout/${companyCode}`,
    path ? { path } : {}
  );
  return response.data;
};

export default {
  getCustomReportLayoutOptions
};
